import React from 'react';
import FooterLinksItem from '../FooterLinksMenu/FooterLinksItem';

export default function CompanyMenu() {
    return (
        <div className="footer-links-menu">
            <ul className="footer-links-menu__items">
                <FooterLinksItem label={__('About')} url="/about" />
                <FooterLinksItem label={__('Contact')} url="/about/contact" />
                <FooterLinksItem label={__('Careers')} url="/about/jobs" />
                <FooterLinksItem label={__('Team')} url="/about/meet-the-team" />
                <FooterLinksItem label={__('Press releases')} url="/about/press-releases" />
                <FooterLinksItem label={__('In the media')} url="/about/media" />
                <FooterLinksItem label={__('Testimonials')} url="/testimonials" />
                <FooterLinksItem label={__('99nonprofits')} url="/nonprofits" />
            </ul>
        </div>
    );
}
